export default "__VITE_ASSET__Dbs_2gTG__"